<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.92 3.52a1.009 1.009 0 0 0-.893-.52c-.38 0-.726.2-.896.517L2.106 16.642a.887.887 0 0 0 .043.913c.182.276.504.445.851.445h14c.346 0 .668-.168.85-.444.183-.276.2-.62.045-.912L10.92 3.52ZM11 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-8a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V7Z" />
    </svg>
</template>
